const AdaptiveNumber = {
    format(value) {
        if (!Number.isFinite(value)) {
            throw new Error('Invalid number');
        }

        const isNegative = value < 0;
        const abs = Math.abs(value);

        const decimals = this._getMaxDecimals(abs);
        const truncated = this._truncate(abs, decimals);
        const parts = truncated.split('.');

        const formattedInt = this._addThousands(parts[0]);
        const result = parts[1] ? formattedInt + '.' + parts[1] : formattedInt;

        return isNegative ? '-' + result : result;
    },

    _getMaxDecimals(abs) {
        if (abs < 0.0001) return 8;
        if (abs < 0.01) return 6;
        if (abs < 1) return 5;
        if (abs < 100) return 4;
        return 2;
    },

    _truncate(abs, decimals) {
        const str = abs.toString();

        if (str.includes('e')) return abs.toFixed(decimals);

        const [int, frac = ''] = str.split('.');
        if (!frac || decimals === 0) return int;

        return int + '.' + frac.slice(0, decimals);
    },

    _addThousands(intPart) {
        return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};

export default AdaptiveNumber;
